export default "__VITE_ASSET__PPzA9y_z__"